import React from "react";
import Blog_60 from "../component/Blog_60";

function Blog_60_container() {
  return <Blog_60 />;
}

export default Blog_60_container;
